export const categoryConfigs = [
    {
        id: 'cooking',
        label: '厨艺',
        title: '做点啥菜？',
        subtitle: '今晚的烟火气，就从这一抽开始。',
        wishLabel: '下厨祈愿',
        emptyTargetLabel: '先定一道今晚最想做成的菜',
        activeTargetLabel: '今晚主线',
        dataSource: '/cooking.json',
        backgroundImage: 'background3.jpg',
        progressLabel: '锅已经热了，灵感也快来了',
        preferenceOptions: [
            { id: 'all', label: '都可以' },
            { id: 'homey', label: '家常治愈' },
            { id: 'feast', label: '来点硬菜' },
            { id: 'clean', label: '清爽一点' },
        ],
        resultCopy: {
            3: '简单也能好吃，今晚开火无压力。',
            4: '有点仪式感了，这顿值得认真做。',
            5: '今晚主厨状态拉满，做一顿像样的。',
        },
    },
    {
        id: 'fitness',
        label: '健身',
        title: '这次练点啥？',
        subtitle: '把纠结交给卡池，把热血留给今天的自己。',
        wishLabel: '开练祈愿',
        emptyTargetLabel: '先选一个今天最想完成的挑战',
        activeTargetLabel: '今日挑战',
        dataSource: '/body.json',
        backgroundImage: 'background2.webp',
        progressLabel: '你的热身已经结束，状态正在爬升',
        preferenceOptions: [
            { id: 'all', label: '都可以' },
            { id: 'steady', label: '稳定推进' },
            { id: 'challenge', label: '来点挑战' },
            { id: 'recovery', label: '恢复一下' },
        ],
        resultCopy: {
            3: '先把基础做扎实，今天这一组很稳。',
            4: '训练质量在线，准备开始出汗。',
            5: '高光挑战已降临，今天给自己来点狠活。',
        },
    },
    {
        id: 'foods',
        label: '正餐',
        title: '今天吃点啥？',
        subtitle: '让仪式感替你做决定，今晚先对自己好一点。',
        wishLabel: '开饭祈愿',
        emptyTargetLabel: '先选一个今天最想吃到的目标',
        activeTargetLabel: '本轮目标',
        dataSource: '/foods.json',
        backgroundImage: 'background.jpg',
        progressLabel: '距离今日好饭更近一步',
        preferenceOptions: [
            { id: 'all', label: '都可以' },
            { id: 'quick', label: '省心快手' },
            { id: 'comfort', label: '治愈安稳' },
            { id: 'reward', label: '奖励自己' },
        ],
        resultCopy: {
            3: '稳稳落地，今天吃它不出错。',
            4: '手气不错，今晚这顿有点意思。',
            5: '金光已出，今天就该吃点好的。',
        },
    }
];

export const defaultCategoryId = categoryConfigs[0].id;

export function getCategoryConfig(categoryId) {
    return categoryConfigs.find((item) => item.id === categoryId) ?? categoryConfigs[0];
}

export function getCategoryByLabel(label) {
    return categoryConfigs.find((item) => item.label === label) ?? categoryConfigs[0];
}
